import React from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <header className="size">
    

<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">Cue Ilisound</a>

  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-bs-controls="navbarNavAltMarkup" aria-bs-expanded="false" aria-bs-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
    <div class="navbar-nav">
      <a class="nav-item nav-link" href="#footer">Acerca De Nosotros <span class="sr-only">(current)</span></a>
      <a class="nav-item nav-link" href="https://wa.me/4433890008/?text=Vengo del sitio web me interesa contratar un servicio" target='_blank'>Contactanos</a>
      <Link class="nav-item nav-link" to="/login">Login</Link>

    </div>
  </div>
</nav>
  </header>
  )
}

export default Header